export var StoryInclude = {
    banner: true,
    actionArea: true,
};
//# sourceMappingURL=Story.js.map